export const ROUTES = {
  /** 내부 라우팅·레지스트리 키(홈 콘텐츠) */
  home: '/',
  /** 운영 주소창 기준 홈(로고·리다이렉트) */
  homePublic: '/home',
  newInstall: '/new-install',
  consult: '/consult',
  differentiatedServices: '/differentiated-services',
  installCaseBoard: '/install-case-board',
  resources: '/resources',
  existing: '/existing',
  evostDemo: '/evost-demo',
  serviceApply: '/service-apply',
  signup: '/signup',
  login: '/login',
  myApplications: '/my/applications',
  myProfile: '/my/profile',
  /** 관리자 모드 — role=admin 전용 (서버 require_admin로 별도 보호) */
  manage: '/manage',
  manageResources: '/manage/resources',
  manageInstallCases: '/manage/install-cases',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
